import { render } from "./BDPieChart.vue?vue&type=template&id=2914630e&scoped=true"
import script from "./BDPieChart.vue?vue&type=script&lang=js"
export * from "./BDPieChart.vue?vue&type=script&lang=js"

import "./BDPieChart.vue?vue&type=style&index=0&id=2914630e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2914630e"]])

export default __exports__